import * as React from "react"
import { cn } from "@/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

const inputVariants = cva(
  "flex w-full border border-input bg-background text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "h-10 px-3 py-2 rounded-md",
        custom:
          "rounded-[10px] xl:h-14.25 lg:h-12 px-3 md:px-6 py-5 md:text-base text-custom-navy-blue font-semibold placeholder:text-sm md:placeholder:text-base  placeholder:font-semibold focus-visible:border-ring focus-visible:ring-primary focus-visible:ring-[2px] focus-visible:ring-offset-0",
        rounded: "h-12 px-4 py-3 rounded-full border-2",
        minimal:
          "h-10 px-3 py-2 rounded-none border-0 border-b-2 bg-transparent focus-visible:ring-0 focus-visible:border-primary",
      },
      size: {
        default: "h-10",
        sm: "h-8 text-sm",
        lg: "h-12 text-lg",
        xl: "h-14.25 text-xl px-6",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">,
    VariantProps<typeof inputVariants> {}

export const CustomInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, size, type, ...props }, ref) => {
    return <input type={type} className={cn(inputVariants({ variant, size, className }))} ref={ref} {...props} />
  },
)
CustomInput.displayName = "CustomInput"
